if (!customElements.get('tabs-element')) {
  class TabsElement extends HTMLElement {
    constructor() {
      super();

      this.navElements = this.querySelectorAll('[data-tabs-nav] a');
      this.tabsContainer = this.querySelector('[data-tabs-container]');
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents() {
      this.navElements.forEach((item) =>
        item.addEventListener('click', this.toggleTabs.bind(this)),
      );
    }

    toggleTabs(event) {
      event.preventDefault();

      event.target
        .closest('[data-tabs-nav]')
        .querySelector('.is-current')
        ?.classList.remove('is-current');

      event.target.classList.add('is-current');

      this.tabsContainer
        .querySelector('.is-current')
        ?.classList.remove('is-current');

      this.tabsContainer
        .querySelector(event.target.getAttribute('href'))
        ?.classList.add('is-current');
    }
  }

  customElements.define('tabs-element', TabsElement);
}
